import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'umss-accordion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class UmssAccordionComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** State props */
  @Input() isOpen: boolean = false;
  @Input() disabled: boolean = false;

  /** Variant props */
  @Input() variant: 'Default' | 'Bordered' | 'Filled' | 'Header Bordered' =
    'Default';
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';

  /** Event outputs */
  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() toggle = new EventEmitter<boolean>();

  /** Event handlers */
  onToggle(): void {
    if (this.disabled) return;
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
    this.toggle.emit(this.isOpen);
  }
}
